import formStyles from '~/Screens/GeneralStyles/formStyle';

const useStyles = (theme) => ({
  ...formStyles(theme),
  description: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 9,
    flex: 1,
    gap: 12,
  },
  submitBtnContainer: {
    marginTop: '-12px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  radioRoot: {
    padding: 7,
    boxSizing: 'border-box',
    border: '2px solid transparent',

    transition: 'border-color 150ms ease, color 150ms ease, background-color 150ms ease',
  },
  fullRowFormControlLabel: {
    width: '100%',
    alignItems: 'flex-start',
  },
  fullRowLabelSlot: {
    display: 'flex',
    flex: '1 1 0',
    minWidth: 0,     
    width: '100%',
  },
});

export default useStyles;
